// extracted by mini-css-extract-plugin
export default {"button":"styles_button__rahXV","outline":"styles_outline__Ynjyj","loading":"styles_loading__zXWM9","disabled":"styles_disabled__PBVMm"};